export default "__VITE_ASSET__CZSV444t__"